import { Box, Section } from '@factorialco/deprecated-design-system'

import Loading from 'modules/core/components/Loading'
import i18n from 'modules/core/lib/i18n'

import 'modules/marketplace/components/IntegrationList/index.styles.css'

import { CategoryItem } from './Category'
import { DeveloperPartnersBanner } from './DeveloperPartnersBanner'
import { EmptyCategoryList } from './EmptyCategoryList'
import { Filters } from './Filters'
import { useIntegrationsCatalog } from './IntegrationsCatalogProvider'

export const IntegrationList = () => {
  const { filteredCategories, loading } = useIntegrationsCatalog()

  return (
    <Box width="full">
      <Section
        paddingX="s80"
        illustration="network-group"
        title={i18n.t('marketplace.integrations.title')}
        description={i18n.t('marketplace.integrations.description')}
        size="600"
      >
        <DeveloperPartnersBanner />
      </Section>
      <Box paddingX="s48" width="full">
        {loading ? (
          <Loading />
        ) : (
          <>
            <Filters />
            <Box className={'IntegrationList_wrapper'} padding="s32">
              {filteredCategories.length === 0 ? (
                <EmptyCategoryList />
              ) : (
                filteredCategories.map((category) => (
                  <CategoryItem key={category.id} category={category} />
                ))
              )}
            </Box>
          </>
        )}
      </Box>
    </Box>
  )
}
